import React, { useState, useEffect } from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { hasChildren } from "./utils";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const MenuList = ({ key, item, mode, selectedItem, selectedIndex, onSelection }) => {
    const Component = hasChildren(item) ? MultiLevel : SingleLevel;

    const handleSelected = (selected) => {
        onSelection(selected);
    };

    return (
        <Box key={key}>
            <Component
                key={key}
                item={item}
                mode={mode}
                onSelection={handleSelected}
                selectedIndex={selectedIndex}
                selectedItem={selectedItem}
            />
        </Box>
    );
};

const SingleLevel = ({ key, item, mode, selectedIndex, selectedItem, onSelection }) => {
    const [itemSelected, setItemSelected] = useState(selectedItem);
    const navigate = useNavigate();
    const handleSelected = (selected) => {
        if (selected?.link) {
            navigate(selected?.link, { replace: false });
        } else if (selected?.onClick) {
            selected?.onClick();
        }

        setItemSelected(selected);
        onSelection(selected);
    };

    return (
        <ListItemButton
            button
            key={item?.id}
            selected={selectedIndex === item?.id}
            id={item?.id}
            onClick={() => handleSelected(item)}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText disableTypography primary={item.title} />
        </ListItemButton>
    );
};

const MultiLevel = ({ item, mode, selectedIndex }) => {
    const { items: children } = item;
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen((prev) => !prev);
    };

    return (
        <>
            <ListItemButton button onClick={handleClick} selected={selectedIndex === 0}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.title} />
                {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {children.map((child, key) => (
                        <MenuList key={key} item={child} mode={mode} />
                    ))}
                </List>
            </Collapse>
        </>
    );
};
export { MenuList };
